import { IFormSwitch, MoveMoneyTypes } from '../interfaces';
import { AchOutTransferFormWrapper } from '../formBlocks/achOutTransfer/AchOutTransferFormWrapper';
import { DomesticWireTransferFormWrapper } from '../formBlocks/domesticWireTransfer/DomesticWireTransferFormWrapper';
import { DomesticAddressFormWrapper } from '../formBlocks/mailCheck/DomesticAddressFormWrapper';
import {
  InternationalWireTransferFormWrapper,
} from '../formBlocks/internationalWireTransfer/InternationalWireTransferFormWrapper';

export const FormSwitch = ({ formMethods, moveType, formType, billId, isVendorUpdateMandatory, vendorData, isUpdateNameRequired }: IFormSwitch) => {
  const getFormByMoveType = () => {
    switch (moveType) {
      case MoveMoneyTypes.WIRE_OUT:
        return <DomesticWireTransferFormWrapper isUpdateNameRequired={isUpdateNameRequired} vendorData={vendorData} moveType={moveType} isVendorUpdateMandatory={isVendorUpdateMandatory} formType={formType} billId={billId} formMethods={formMethods} />;
      case MoveMoneyTypes.INTERNATIONAL_WIRE_OUT:
        return <InternationalWireTransferFormWrapper isUpdateNameRequired={isUpdateNameRequired} vendorData={vendorData} moveType={moveType} isVendorUpdateMandatory={isVendorUpdateMandatory} formType={formType} billId={billId} formMethods={formMethods} />;
      case MoveMoneyTypes.ACH_OUT_TRANSFER:
        return <AchOutTransferFormWrapper isUpdateNameRequired={isUpdateNameRequired} vendorData={vendorData} moveType={moveType} isVendorUpdateMandatory={isVendorUpdateMandatory} formType={formType} billId={billId} formMethods={formMethods} />;
      case MoveMoneyTypes.MAIL_CHECK:
        return <DomesticAddressFormWrapper isUpdateNameRequired={isUpdateNameRequired} vendorData={vendorData} moveType={moveType} isVendorUpdateMandatory={isVendorUpdateMandatory} formType={formType} billId={billId} formMethods={formMethods} />;

      default:
        return null;
    }
  };

  return getFormByMoveType();
};
